import React from 'react';

import { appRoutes } from '@clearverify/constants';

import { DEFAULT_AVATAR } from 'src/assets';
import { BaseLayoutHeader, LeftMenuLogo } from 'src/components/common';
import { BREADCRUMBS_PEO_PAYROLL_PROVIDER } from 'src/constants/breadcrumbs';
import { useScreenInfo } from 'src/hooks/common';
import { useGlobalState } from 'src/hooks/shared';
import { useCurrentUser, useUserAvatar } from 'src/hooks/user';

export const LayoutHeader: React.FC = () => {
  const { leftMenuDrawerState } = useGlobalState();
  const { isMobile } = useScreenInfo();

  const { user } = useCurrentUser();
  const { userAvatar } = useUserAvatar(user?.id);

  return (
    <BaseLayoutHeader
      rootRoute={
        user?.peoPayrollProviderStaff?.isPartnershipCompany
          ? appRoutes.employers.index
          : appRoutes.inbox.index
      }
      logoutRoute={appRoutes.auth.logout}
      currentUser={user}
      currentUserAvatarUrl={userAvatar?.downloadUrl}
      defaultLogoUrl={DEFAULT_AVATAR}
      leftMenuDrawerState={leftMenuDrawerState}
      breadCrumbs={BREADCRUMBS_PEO_PAYROLL_PROVIDER}
      accountRoute={appRoutes.account.index}
      leftLogo={isMobile ? <LeftMenuLogo /> : null}
    />
  );
};
